import { render } from "./AddSong.vue?vue&type=template&id=d547dc72&scoped=true"
import script from "./AddSong.vue?vue&type=script&lang=js"
export * from "./AddSong.vue?vue&type=script&lang=js"

import "./AddSong.vue?vue&type=style&index=0&id=d547dc72&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d547dc72"

export default script